export const languagesData = [
    {
        data: "us",
        language: "English",
    },
    {
        data: "fr",
        language: "Français",
    },
    {
        data: "es",
        language: "Español",
    },
];

export const cartHeaderData = [
    {
        id: 1,
        src: '1.png',
        name: 'Watch multicolor',
        price: '500'
    },
    {
        id: 2,
        src: '2.png',
        name: 'Airpods',
        price: '500.00'
    },
];

//setting-icon
export const settingIconData = [
    {
        id: 1,
        icon: 'Profile',
        link: 'users/user_edit',
        text: 'Account',
    },
    // {
    //     id: 22,
    //     icon: 'Message',
    //     link: 'email/letter_box',
    //     text: 'Inbox'
    // },
    // {
    //     id: 3,
    //     icon: 'Document',
    //     link: 'app/todo',
    //     text: 'Task'
    // }
]